import { ChakraProvider } from '@chakra-ui/react';
import { ReactNode } from 'react';
import tema from './tema/tema';

const StylesProvider = ({ children }: { children: ReactNode }) => {
  return <ChakraProvider theme={tema}>{children}</ChakraProvider>;
};

export default StylesProvider;
